import React from "react";
import _ from "lodash";
import set from "@rill/set";
import { S3 } from "../../../constants";
import AccountHelpers from "../../../utils/account-helpers";
import Avatar from "../../../parts/avatar";
import PlanTile from "./components/PlanTile";
import generateAvatarSVG from "../../../utils/generate-avatar-svg";
import { useRillContext } from "../../../rill/RillReact/share/base";

function View(props) {
  const { locals } = useRillContext();

  const { activeUser, momentTZ, permissions, activeUserToRequest } = locals;

  const [firstName, lastName] = _.get(activeUser, "name", "").split(/ +/);

  const avatarPath = _.get(activeUser, "avatar.s3Path");
  const avatarURL = avatarPath
    ? `${S3.PATH}${avatarPath}`
    : firstName && lastName
    ? generateAvatarSVG(firstName, lastName)
    : "/img/avatar-placeholder.webp";

  const accountType = AccountHelpers.getGreatestPermissionLevel(permissions);

  return (
    <div className="Main Profile">
      <div className="Profile-Preview tile">
        <Avatar size={180} />
        <div className="name">
          <b>{_.get(activeUser, "name")}</b>
          {locals.getCountryName(_.get(activeUser, "country", "CA"))}
        </div>

        <div className="details">
          <div className="col">
            <b>Date of Birth</b>
            {momentTZ(_.get(activeUser, "birthday")).format("MMMM D, YYYY")}
          </div>

          <div className="col">
            <b>Gender</b>
            {_.capitalize(_.get(activeUser, "gender"))}
          </div>

          <div className="col">
            <b>Body Weight</b>
            {locals.withWeight(
              locals.fromMetric(_.get(activeUser, "weight", 0))
            )}
          </div>
        </div>

        <div className="member-since">
          <b>Member since</b>{" "}
          {momentTZ(_.get(activeUser, "registered")).format("MMMM, YYYY")}
        </div>

        <a href="/dashboard/settings/profile" className="text-button icon">
          <img src="/img/svg/icon_edit_white.svg" alt="icon" />
          Edit Profile
        </a>
      </div>

      <PlanTile
        type={accountType}
        user={activeUserToRequest}
        momentTZ={momentTZ}
      />

      <div className="MSB-Support tile">
        <div className="inset">
          <b>
            To get the most out of MyStengthBook check out our helpful
            resources.
          </b>
          <a href="/dashboard/support" className="button outline">
            MSB Support
          </a>
        </div>
      </div>
    </div>
  );
}

const ProfileController = (app) => {
  app.get(
    "/profile",
    set("heading", ["Your Profile"]),
    async ({ res, api, locals }) => {
      res.body = <View />;
    }
  );
};

export default ProfileController;
